// This might not be necessary anymore with Webpack 2 treeshaking
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./store.prod');
} else {
  module.exports = require('./store.dev');
}
